module.exports = __webpack_public_path__ + "img/P18-en.f9ff2277.png";